export default __webpack_public_path__ + "static/media/Sohail_Zindani.afdcde27.png";